import { create } from 'zustand';

export type CacheURLSearchParams = Record<string, string>;

export type NavigateStore = {
  cacheLocation?: {
    pathname: string;
    search: string;
  };
  urlSearchParams?: CacheURLSearchParams;
  setCacheLocation: (cacheLocation: NavigateStore['cacheLocation']) => void;
  setUrlSearchParams: (urlSearchParams: CacheURLSearchParams) => void;
};

export const useNavigateStore = create<NavigateStore>()((set) => ({
  cacheLocation: undefined,
  setCacheLocation: (cacheLocation) => set({ cacheLocation }),
  setUrlSearchParams: (urlSearchParams) => set({ urlSearchParams }),
}));

export default useNavigateStore;
